module.exports = __webpack_public_path__ + "static/media/co-work.ddc6f109.png";